module.exports = __webpack_public_path__ + "img/whatsapp.836150e9.png";